<!--
 * @Description: 接单权弹框
 * @Author: fengal
 * @Date: 2024-06-04 11:43:52
-->
<template>
  <div class="body">
    <el-dialog class="dispatch" width="1032px" title="医院接单权" :visible.sync="visible" :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
      <div class="attendant">
        {{attendant.attendantName}}
        <span>
          {{attendant.institutionName}}
        </span>
      </div>
      <el-checkbox v-model="attendant.acceptPvgFlag" style="margin-left: 25px;" @change="(val) => handleChangeAccept(val)">接单权</el-checkbox>
      <div class="hospital">
        <div class="title">可接单医院</div>
        <el-tag v-for="tag in selectedHospital" :key="tag.hospitalId" closable @close="handleClose(tag.hospitalId)">
          <span>{{ tag.hospitalName }}</span>
        </el-tag>
        <div v-if="!selectedHospital.length" class="empty-block">
          <img src="@/assets/instmng/instlist/img-instmng-empty-hospital.png" alt="">
        </div>  
      </div>
      <div class="hspDeptDOList">
        <div class="content">
          <div class="hspList">
            <div class="title">
              <span>医院列表</span>
            </div>
            <el-checkbox class="checkedAll" v-model="attendant.checkedAllHsp" :indeterminate="isIndeterminate" @change="checkAllChange">全选</el-checkbox>
            <div class="hsp" v-for="(item, index) in hspDeptDOList" :key="item.hospitalId" :class="item.hospitalId == curHsp.hospitalId ? 'activeHsp' : 'commonHsp'" @click.stop="handleClickHsp(item)">
              <el-checkbox v-model="item.hospitalSelectFlag" :true-label="1" :false-label="0" @change="(val)=>hspSelectFlagChange(val, index)"></el-checkbox>
              <span>
                {{item.hospitalName}}
              </span>
            </div>
          </div>
          <div class="deptList">
            <div class="title">
              <span>科室列表</span>
            </div>
            <div class="filter-box" v-show="activeDeptList.length">
              <el-input placeholder="搜索" prefix-icon="el-icon-search" size="small" v-model="filterText"></el-input>
            </div>
            <el-checkbox class="checkedAll" v-show="activeDeptList.length" v-model="checkedAllDept" :indeterminate="isIndeterminateDept" @change="handleCheckAllDeptChange">全选</el-checkbox>
            <el-tree :data="activeDeptList" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current :props="defaultProps" :default-checked-keys="checkedKeys" :filter-node-method="filterNode" @check="handleCheckChange">
            </el-tree>
          </div>
          <div class="deptList">
            <div class="title">
              <span>服务列表</span>
            </div>
            <div class="filter-box" v-show="curServiceList.length">
              <el-input placeholder="搜索" prefix-icon="el-icon-search" size="small" v-model="filterServiceText"></el-input>
            </div>
            <el-checkbox class="checkedAll" v-show="curServiceList.length" v-model="checkedAllService" :indeterminate="isIndeterminateService" @change="handleCheckAllServiceChange">全选</el-checkbox>
            <el-tree :data="curServiceList" show-checkbox default-expand-all node-key="id" ref="serviceTree" highlight-current :props="defaultServiceProps" :default-checked-keys="checkedServiceKeys" :filter-node-method="filterNode" @check="handleCheckServiceChange"></el-tree>
          </div>
        </div>
      </div>
      <div class="bk-wizard-bottons" style="text-align: center;">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'SetupDispatchPvg',
  props: ['visible', 'attendantId'],

  data() {
    return {
      attendant: {},
      hspDeptDOList: [],
      isIndeterminate: true,
      selectedHospital: [],
      curHsp: {},
      activeDeptList: [],
      checkedAllDept: false,
      isIndeterminateDept: true,
      defaultProps: {
        children: 'department2List',
        label: 'name',
      },
      checkedKeys: [],
      filterText: '',

      // 服务列表相关变量
      hospitalHserviceDOList: [],
      curServiceList: [],
      checkedAllService: true,
      isIndeterminateService: true,
      defaultServiceProps: {
        children: 'hserivceModeList',
        label: 'name',
      },
      checkedServiceKeys: [],
      filterServiceText: '',
    }
  },

  methods: {
    async initData() {
      await this.getAttendantDoDispatchPvg()
    },

    getAttendantDoDispatchPvg() {
      return new Promise((resolve) => {
        let params =  {attendantId: this.attendantId}
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_ATTENDANT_DO_ACCEPT_PVG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return
          }
          this.attendant = result.data || {}
          this.hspDeptDOList = result.data.hospitalDepartmentDOList || []
          if (this.hspDeptDOList.length > 0) {
            this.curHsp = this.hspDeptDOList[0]
            this.activeDeptList = this.curHsp.department1List || []
            this.checkedAllDept = this.curHsp.hospitalSelectFlag ? true : false
            this.isIndeterminateDept = this.curHsp.deptPartSelectFlag ? true : false
          }

          this.hospitalHserviceDOList = result.data.hospitalHserviceDOList || [];
          if (this.hospitalHserviceDOList.length > 0) {
            this.curServiceList = this.hospitalHserviceDOList[0].hserviceModeDTOList || []
          }

          resolve(result.data)
        })
      })
    },

    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    handleChangeAccept(val) {
      if (!this.selectedHospital.length && val) this.$set(this.attendant, 'acceptPvgFlag', false)
    },

    // 选中医院
    getSelectedHsp(data) {
      const arr = JSON.parse(JSON.stringify(data));
      const result = [];

      for (const obj of arr) {
        if (obj.hospitalSelectFlag === 1 && !obj.deptPartSelectFlag) {
          result.push({
            hospitalId: obj.hospitalId,
            hospitalName: obj.hospitalName + '(全部科室)',
          });
        } else if (obj.hospitalSelectFlag === 1) {
          const hospitalName = this.generateHspName(obj);
          if (hospitalName) {
            result.push({
              hospitalId: obj.hospitalId,
              hospitalName: hospitalName
            });
          }
        }
      }

      this.$set(this, 'selectedHospital', result);
      if (!this.selectedHospital.length) this.$set(this.attendant, 'acceptPvgFlag', false);
    },

    generateHspName(obj) {
      const selectedDepts = obj.department1List.map(dept1 => {
        if (dept1.selectFlag === 1) {
          return dept1.name;
        }
        
        const dept1Names = dept1.department2List
          .filter(dept2 => dept2.selectFlag === 1)
          .map(dept2 => dept2.name);
        
        return dept1Names.length > 0 ? `${dept1.name}-${dept1Names.join('、')}` : null;
      }).filter(Boolean); // 移除 null 和 undefined

      return selectedDepts.length > 0 ? `${obj.hospitalName}(${selectedDepts.join('; ')})` : null;
    },

    // 删除可接单医院tag
    handleClose(id) {
      const idx = this.hspDeptDOList.findIndex((item) => item.hospitalId == id)
      if (idx < 0) return
      this.hspSelectFlagChange(0, idx)
      this.hspDeptDOList[idx].hospitalSelectFlag = 0
      if (this.hspDeptDOList.findIndex((item) => item.hospitalSelectFlag) === -1)
        this.$set(this.attendant, 'checkedAllHsp', false)
      if (!this.selectedHospital.length) this.$set(this.attendant, 'acceptPvgFlag', false)
    },

    // 获取当前选中医院科室的所有key
    getSelectedDeptKey() {
      this.checkedKeys = []
      this.activeDeptList.forEach((item) => {
        if (item.selectFlag) this.checkedKeys.push(item.id)
        item.department2List.forEach((dept) => {
          if (dept.selectFlag) this.checkedKeys.push(dept.id)
        })
      })
    },

    // 医院接单权状态修改
    hspSelectFlagChange(val, index) {
      this.hspDeptDOList[index].deptPartSelectFlag = false
      this.hspDeptDOList[index].hospitalSelectFlag = val ? 1 : 0
      Array.from(this.hspDeptDOList[index].department1List, (dept) => {
        dept.selectFlag = val ? 1 : 0
        Array.from(dept.department2List, (dept2) => (dept2.selectFlag = val ? 1 : 0))
        return dept
      })
      if (this.curHsp.hospitalId === this.hspDeptDOList[index].hospitalId) {
        this.activeDeptList = this.hspDeptDOList[index].department1List
        this.checkedAllDept = val ? true : false
        this.isIndeterminateDept = false
      }
      this.$set(
        this.attendant,
        'acceptPvgFlag',
        val || this.selectedHospital.length ? true : false
      )

      this.handleCheckAllServiceChange(val);
    },

    // 医院全选状态修改
    checkAllChange(val) {
      this.setAcceptPvgFlag(val);
      this.setHspSelectFlags(val);
      this.setCheckedKeys(val);
      this.setIndeterminateDept(false);
      this.handleCheckAllServiceChange(val);
    },

    setHspSelectFlags(val) {
      for (const item of this.hspDeptDOList) {
        item.hospitalSelectFlag = val ? 1 : 0;
        item.deptPartSelectFlag = false;
        this.setDeptSelectFlags(item.department1List, val);
      }
    },

    setDeptSelectFlags(department1List, val) {
      for (const dept of department1List) {
        dept.selectFlag = val ? 1 : 0;
        this.setDept2SelectFlags(dept.department2List, val);
      }
    },

    setDept2SelectFlags(department2List, val) {
      for (const dept2 of department2List) {
        dept2.selectFlag = val ? 1 : 0;
      }
    },

    setAcceptPvgFlag(val) {
      this.$set(this.attendant, 'acceptPvgFlag', val);
    },

    setCheckedKeys(val) {
      this.checkedKeys = [];
      if (val) {
        this.checkedAllDept = true;
        for (const item of this.activeDeptList) {
          this.checkedKeys.push(item.id);
        }
      } else {
        this.checkedAllDept = false;
        this.$refs.tree.setCheckedKeys([]);
      }
    },

    setIndeterminateDept(val) {
      this.isIndeterminateDept = val;
    },

    // 科室全选状态修改
    handleCheckAllDeptChange(val) {
      this.checkedKeys = []
      this.checkedAllDept = val ? true : false
      this.isIndeterminateDept = false

      this.activeDeptList.forEach((item) => {
        if (val) this.checkedKeys.push(item.id)
        item.selectFlag = val ? 1 : 0
        item.department2List.forEach((item2) => {
          item2.selectFlag = val ? 1 : 0
        })
      })

      if (!val) {
        this.$refs.tree.setCheckedKeys([])
      }

      let index = this.hspDeptDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      this.$set(this.hspDeptDOList[index], 'department1List', this.activeDeptList)
      this.$set(this.hspDeptDOList[index], 'hospitalSelectFlag', val ? 1 : 0)
      this.$set(this.hspDeptDOList[index], 'deptPartSelectFlag', false)
    },

    // 切换当前选中医院
    handleClickHsp(item) {
      this.curHsp = item
      this.activeDeptList = this.curHsp.department1List
      this.checkedAllDept = item.hospitalSelectFlag ? true : false
      this.isIndeterminateDept = item.deptPartSelectFlag ? true : false
      this.hospitalHserviceDOList.forEach(hsp => {
        if (hsp.hospitalId === item.hospitalId) {
          this.curServiceList = hsp.hserviceModeDTOList || []
          return false
        }
      });
    },

    handleCheckChange() {
      let checkArr = this.$refs.tree.getCheckedKeys()
      this.activeDeptList.forEach((item) => {
        item.selectFlag = 0
        if (checkArr.includes(item.id)) {
          item.selectFlag = 1
        }
        item.department2List.forEach((dept) => {
          dept.selectFlag = 0
          if (checkArr.includes(dept.id)) {
            dept.selectFlag = 1
            return false
          }
        })
      })

      let arr = []
      this.activeDeptList.forEach((item) => {
        arr.push(item.id)
        item.department2List.forEach((dept) => {
          arr.push(dept.id)
        })
      })
      if (!checkArr.length) {
          this.checkedAllDept = false
          this.isIndeterminateDept = false
        } else if (checkArr.length === arr.length) {
          this.checkedAllDept = true
          this.isIndeterminateDept = false
        } else {
          this.checkedAllDept = true
          this.isIndeterminateDept = true
        }

      let index = this.hspDeptDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag =  this.checkedAllDept ? 1 : 0
      this.$set(this.hspDeptDOList[index], 'department1List', this.activeDeptList)
      this.$set(this.hspDeptDOList[index], 'hospitalSelectFlag', flag)
      this.$set(this.hspDeptDOList[index], 'deptPartSelectFlag', this.isIndeterminateDept)
    },

    // 服务全选状态修改
    handleCheckAllServiceChange(val) {
      this.checkedServiceKeys = []
      this.checkedAllService = val ? true : false
      this.isIndeterminateService = false

      this.curServiceList.forEach((item) => {
        if (val) this.checkedServiceKeys.push(item.id)
        item.selectFlag = val ? 1 : 0
        item.hserivceModeList.forEach((item2) => {
          item2.selectFlag = val ? 1 : 0
        })
      })

      if (!val) {
        this.$refs.serviceTree.setCheckedKeys([])
      }

      // 找到对应序列医院
      let index = this.hospitalHserviceDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag = val ? 1 : 0
      this.$set(this.hospitalHserviceDOList[index], 'hserviceModeDTOList', this.curServiceList)
      this.$set(this.hospitalHserviceDOList[index], 'hospitalSelectFlag', flag)
      // 修改对应医院选中状态
      this.$set(this.hspDeptDOList[index], 'hospitalSelectFlag', flag)
    },

    // 服务列表树选中状态修改
    handleCheckServiceChange() {
      let checkArr = this.$refs.serviceTree.getCheckedKeys()
      this.curServiceList.forEach((item) => {
        item.selectFlag = 0
        if (checkArr.includes(item.id)) {
          item.selectFlag = 1
        }
        item.hserivceModeList.forEach((Service) => {
          Service.selectFlag = 0
          if (checkArr.includes(Service.id)) {
            Service.selectFlag = 1
            return false
          }
        })
      })

      let arr = []
      this.curServiceList.forEach((item) => {
        arr.push(item.id)
        item.hserivceModeList.forEach((service) => {
          arr.push(service.id)
        })
      })
      if (!checkArr.length) {
          this.checkedAllService = false
          this.isIndeterminateService = false
        } else if (checkArr.length === arr.length) {
          this.checkedAllService = true
          this.isIndeterminateService = false
        } else {
          this.checkedAllService = true
          this.isIndeterminateService = true
        }

      let index = this.hospitalHserviceDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag =  this.checkedAllService ? 1 : 0
      this.$set(this.hospitalHserviceDOList[index], 'hserviceModeDTOList', this.curServiceList)
      this.$set(this.hospitalHserviceDOList[index], 'hospitalSelectFlag', flag)
      this.$set(this.hspDeptDOList[index], 'hospitalSelectFlag', flag)
    },

    // 数据结构处理
    updateSelectFlag(arr) {
      let hospitals = JSON.parse(JSON.stringify(arr))
      
      for (let item of hospitals) {
        delete item.deptAllSelectFlag;
        delete item.deptPartSelectFlag;
      }
      return hospitals
    },

    // 发起修改接单权请求
    updateAccept(obj) {
      let header = this.encryptionUtil.signatureBody({...obj},
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_OR_UPDATE_ATTENDANT_ACCEPT_PVG,
        param: obj,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };

      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return
        }
        this.$emit('close-dialog', true)
      })
    },

    handleSubmit() {
      const { attendantId, institutionId, acceptPvgFlag } = this.attendant
      let obj = { attendantId, institutionId, acceptPvgFlag }
      obj.hospitalDepartmentDOList = this.updateSelectFlag(this.hspDeptDOList)
      obj.hospitalHserviceDOList = this.updateSelectFlag(this.hospitalHserviceDOList)
      this.updateAccept(obj)
    },

    handleCancel() {
      this.clearData()
      this.$emit('close-dialog', false)
    },

    // 设置当前选中服务下的默认选中项
    setSelServiceKeys() {
      this.checkedServiceKeys = [];
      this.curServiceList.forEach((item) => {
        if (item.selectFlag) this.checkedServiceKeys.push(item.id)
        item.hserivceModeList.forEach((svc) => {
          if (svc.selectFlag) this.checkedServiceKeys.push(svc.id)
        })
      })
    },

    clearData() {
      this.filterText = ''
      this.attendant = {}
      this.hospital = []
      this.hspDeptDOList = []
    },
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },

    filterServiceText(val) {
      this.$refs.serviceTree.filter(val)
    },

    hspDeptDOList: {
      handler(newVal, _oldVal) {
        const count1 = this.hspDeptDOList.filter(
          (hospital) => hospital.hospitalSelectFlag === 1 && !hospital.deptPartSelectFlag
        ).length
        const count2 = this.hspDeptDOList.filter(
          (hospital) => hospital.hospitalSelectFlag === 0).length

          if (count1 === this.hspDeptDOList.length) {
          this.isIndeterminate = false
          this.$set(this.attendant, 'checkedAllHsp', true)
        } else if (count2 === this.hspDeptDOList.length) {
          this.isIndeterminate = false
          this.$set(this.attendant, 'checkedAllHsp', false)
        } else {
          this.isIndeterminate = true
          this.$set(this.attendant, 'checkedAllHsp', false)
        }
        this.getSelectedHsp(newVal)
      },
      deep: true,
      immediate: true,
    },

    activeDeptList: {
      handler(_newVal, _oldVal) {
        this.getSelectedDeptKey()
        if (!this.checkedKeys.length) this.$refs.tree.setCheckedKeys([])
      },
      deep: true,
    },

    curServiceList: {
      handler: function(newVal, _oldVal) {
        // 设置tree默认选中项
        this.setSelServiceKeys()
        // 获取一级tree节点选中个数
        const trueFlagCount = newVal.filter(obj => obj.selectFlag).length;
        if (!this.checkedServiceKeys.length) {
          // 不选
          this.$refs.serviceTree.setCheckedKeys([])
          this.checkedAllService = false;
          this.isIndeterminateService = false;
        } else if (trueFlagCount === newVal.length) {
          // 全选
          this.checkedAllService = true;
          this.isIndeterminateService = false;
        } else {
          // 部分选
          this.checkedAllService = true;
          this.isIndeterminateService = true;
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.dispatch >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.attendant {
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  margin-bottom: 30px;
  padding: 0 25px;
}
.attendant span {
  margin-left: 10px;
  font-size: 16px;
  color: #8f9399;
}
.hospital,
.hspDeptDOList {
  background-color: #f7f8fa;
  margin: 30px 25px 10px 25px;
  padding-bottom: 10px;
}
.hospital {
  padding: 10px 30px;
}
.hspDeptDOList {
  position: relative;
  max-height: 464px;
  overflow-y: auto;
}
.content {
  margin: 30px 30px 10px 30px;
  background: #fff;
  display: flex;
}
.hspList,
.deptList {
  /* max-height: 180px; */
  max-height: 360px;
  overflow-y: auto;
  /* padding: 0 15px; */
  border: 1px solid #e7e7e7;
}
.hspList {
  width: 315px;
}
.deptList {
  flex: 1;
}
.hsp-name {
  color: #606266;
  font-weight: 500;
  cursor: pointer;
}
.hospital >>> .el-tag {
  margin: 0 10px 10px 0;
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  white-space: normal;
  height: auto;
  padding: 0 10px;
  font-size: 12px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hospital >>> .el-tag .el-icon-close {
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  height: 12px;
  width: 12px;
  line-height: 12px;
  vertical-align: middle;
  top: -1px;
  right: -5px;
  color: #949da6;
  border: 1px solid #949da6;
}
.hospital >>> .el-tag .el-icon-close:hover {
  color: #fff;
  border: 1px solid #e6f1fc;
}
.empty-block {
  text-align: center;
}
.empty-block img {
    width: 107px;
    height: 67px;
}
.title {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #5b5b5b;
  font-size: 16px;
  margin-bottom: 10px;
}
.hsp {
  padding: 10px 15px;
}
.activeHsp {
  background: #f4f7ff;
  cursor: pointer;
}
.commonHsp {
  background: #fff;
  cursor: pointer;
}
.checkedAll {
  margin: 10px 15px;
}
.group {
  margin: 20px 36px 0;
}
.el-tree {
  padding: 0 10px;
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.deptList >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #fff !important;
}
.filter-box {
  padding: 0 15px;
}
.filter-box >>> .el-input__inner {
  border-radius: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/SetupAcceptPvg.vue